import React from "react";

import { Props } from "./types";

function UploadIcon({ className }: Props) {
  return (
    <svg viewBox="0 0 15.328 20.438" className={className}>
      <path d="M8.941,5.429V0H.958A.956.956,0,0,0,0,.958V19.479a.956.956,0,0,0,.958.958H14.37a.956.956,0,0,0,.958-.958V6.387H9.9A.961.961,0,0,1,8.941,5.429Zm2.6,8.622h-2.6v3.193a.638.638,0,0,1-.639.639H7.025a.638.638,0,0,1-.639-.639V14.051h-2.6a.639.639,0,0,1-.45-1.092l3.849-3.82a.681.681,0,0,1,.96,0l3.849,3.82A.638.638,0,0,1,11.543,14.051Zm3.506-9.86L11.141.279A.957.957,0,0,0,10.462,0h-.243V5.109h5.109V4.866A.955.955,0,0,0,15.049,4.191Z" />
    </svg>
  );
}

export { UploadIcon };
